import { render, staticRenderFns } from "./RatesUpdate.vue?vue&type=template&id=0e25fec4&scoped=true&"
import script from "./RatesUpdate.vue?vue&type=script&lang=js&"
export * from "./RatesUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RatesUpdate.vue?vue&type=style&index=0&id=0e25fec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e25fec4",
  null
  
)

export default component.exports